import { lazy } from "react";

import { ROLE } from "./roles";
import Dashboard from "../portal/Dashboard";
import PromoCodeList from "../portal/PromoCode/PromoCodeList";
import PaymentSettlement from "../portal/student/paymentSettlement/PaymentSettlement";

const BatchList = lazy(() => import("../portal/Batch/BatchList"));
const FranchiseeUserList = lazy(
  () => import("../portal/UserMaster/UserMasterFranchisee")
);
const CourseInstructor = lazy(
  () => import("../portal/CourseInstructor/CourseInstructor")
);
const FranchiseGroupList = lazy(
  () => import("../portal/franchiseGroup/FranchiseeGroupList")
);
const Feedback = lazy(() => import("../portal/Feedback/FeedbackForm"));
const UserRole = lazy(() => import("../portal/UserRole/UserRole"));
const RoleAccess = lazy(() => import("../portal/RoleAccess/RoleAccess"));
const UserMasterHo = lazy(() => import("../portal/UserMasterHo/UserMasterHo"));
const ChangePassword = lazy(
  () => import("../auth/forgotpassword/ChangePassword")
);
const FranchiseMasterHo = lazy(
  () => import("../portal/franchiseMasterHo/FranchiseMasterHo")
);
const RedeemPointOrder = lazy(
  () => import("../portal/purchaseHO/redeemPointOrder/RedeemPointOrder")
);
const StudentInvoice = lazy(
  () => import("../portal/StudentInvoice/StudentInvoice")
);

const InternalPurchaseOrder = lazy(
  () =>
    import("../portal/purchaseHO/internalPurchaseOrder/InternalPurchaseOrder")
);
const PurchaseReturn = lazy(
  () => import("../portal/purchaseHO/purchase-HO/purchaseReturn/PurchaseReturn")
);
const SmsOrder = lazy(() => import("../portal/smsOrder/smsOrder"));
const CustomerDiscount = lazy(
  () => import("../portal/purchaseHO/customerDiscount/CustomerDiscount")
);
const SendNotificationHo = lazy(
  () => import("../portal/sendNotification/sendNotificationHo")
);
const Payment = lazy(() => import("../portal/purchaseHO/payment/PaymentHo"));
const ItemMaster = lazy(() => import("../portal/itemMaster/itemMaster"));
const StudentMaster = lazy(
  () => import("../portal/studentMaster/StudentMasterList")
);
const StudentDetails = lazy(
  () => import("../portal/studentMaster/studentsDetails/studentDetails")
);
const StudentAttendance = lazy(
  () => import("../portal/attendance/studentAttendance")
);
const PaymentsGateway = lazy(
  () => import("../portal/paymentsGateway/paymentsGateway")
);
const CertificateBookingPrinting = lazy(
  () =>
    import("../portal/certificateBookingPrinting/CertificateBookingAndPrinting")
);
const LeadList = lazy(() => import("../portal/student/leads/LeadList"));
const DispatchRedeemedProduct = lazy(
  () =>
    import("../portal/Purchase/dispatchRedeemedProduct/DispatchRedeemedProduct")
);
const DispatchRedeemedProductHo = lazy(
  () =>
    import(
      "../portal/purchaseHO/dispatchRedeemProductHo/DispatchRedeemedProductHo"
    )
);
const StudentRedeemPointOrder = lazy(
  () =>
    import("../portal/Purchase/studentRedeemPointOrder/RedeemPointOrderList")
);
const PaymentSummary = lazy(
  () => import("../portal/Purchase/paymentSummary/PaymentSummary")
);
const Outstanding = lazy(
  () => import("../portal/Purchase/outstanding/Outstanding")
);
const Order = lazy(() => import("../portal/Purchase/order/Order"));
const KitOutstandingHo = lazy(
  () => import("../portal/purchaseHO/kitOutstandingHo/KitOutstandingHo")
);
const DashboardHo = lazy(() => import("../portal/dashboardHo"));
const Reports = lazy(() => import("../portal/reports/ReportHo"));
const SendEmailSms = lazy(
  () => import("../portal/sendNotification/sendEmailSMS")
);
const Template = lazy(
  () => import("../portal/sendNotification/template/Template")
);
const EmailSentHistory = lazy(
  () => import("../portal/sendNotification/history/EmailSentHistory")
);
const AdminSettings = lazy(
  () => import("../portal/AdminSetting/AdminSettings")
);

const DispatchPurchaseOrder = lazy(
  () => import("../portal/DispatchPurchaseOrder/DispatchPurchaseOrderHO")
);
const CertificateRequest = lazy(
  () => import("../portal/student/certificateRequest/CertificateRequest")
);

const MyProfile = lazy(() => import("../portal/myProfile/MyProfile"));

export const Routings = [
  {
    path: "change-password",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER, ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <ChangePassword />,
  },
  {
    path: "dashboardHO",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <DashboardHo />,
  },
  // Franchisee Menus
  {
    path: "dashboard",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <Dashboard />,
  },
  {
    path: "batch-list",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <BatchList />,
  },
  {
    path: "course-instructor",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <CourseInstructor />,
  },
  {
    path: "feedback",
    isAuthenticate: true,
    roles: [ROLE.FA_ADMIN, ROLE.HO_USER, ROLE.FA_USER],
    component: <Feedback />,
  },
  {
    path: "admin-settings",
    isAuthenticate: true,
    roles: [ROLE.FA_ADMIN, ROLE.HO_USER, ROLE.FA_USER],
    component: <AdminSettings />,
  },
  {
    path: "franchisee-master",
    isAuthenticate: true,
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <FranchiseMasterHo />,
  },
  {
    path: "user-master",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <FranchiseeUserList />,
  },
  {
    path: "student-lead-management",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <LeadList />,
  },
  {
    path: "student-master",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <StudentMaster />,
  },
  {
    path: "student-details",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <StudentDetails />,
  },
  {
    path: "student-invoice",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <StudentInvoice />,
  },
  {
    path: "payments-gateway",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <PaymentsGateway />,
  },
  {
    path: "certificate-booking-printing",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <CertificateBookingPrinting />,
  },
  {
    path: "student-attendance",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <StudentAttendance />,
  },
  {
    path: "order",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <Order />,
  },
  {
    path: "purchase-return",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <PurchaseReturn />,
  },
  {
    path: "outstanding",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <Outstanding />,
  },
  {
    path: "payment-summary",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <PaymentSummary />,
  },
  {
    path: "student-redeem-point-order",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <StudentRedeemPointOrder />,
  },
  {
    path: "dispatch-redeemed-product",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <DispatchRedeemedProduct />,
  },
  {
    path: "manage-reports",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <Reports />,
  },
  {
    path: "send-email-sms",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <SendEmailSms />,
  },
  {
    path: "template",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <Template />,
  },
  {
    path: "sent-history",
    roles: [ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <EmailSentHistory />,
  },
  // HO Menus
  {
    path: "admin-user-master",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <UserMasterHo />,
  },
  {
    path: "user-role",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <UserRole />,
  },
  {
    path: "role-access",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <RoleAccess />,
  },
  {
    path: "franchisee-master",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <FranchiseMasterHo />,
  },
  {
    path: "item-master",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <ItemMaster />,
  },
  {
    path: "franchisee-group",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <FranchiseGroupList />,
  },
  {
    path: "promo-code",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <PromoCodeList />,
  },
  {
    path: "certificate-request",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <CertificateRequest />,
  },
  {
    path: "payment-gateway-settlement",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <PaymentSettlement />,
  },
  {
    path: "sms-order",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <SmsOrder />,
  },
  {
    path: "kit-outstanding",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <KitOutstandingHo />,
  },
  {
    path: "customer-discount",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <CustomerDiscount />,
  },
  {
    path: "internal-purchase-order",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <InternalPurchaseOrder />,
  },
  {
    path: "dispatch-purchase-order",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <DispatchPurchaseOrder />,
  },
  {
    path: "ho-purchase-return",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <PurchaseReturn />,
  },
  {
    path: "payment",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <Payment />,
  },
  {
    path: "redeem-point-order",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <RedeemPointOrder />,
  },
  {
    path: "ho-dispatch-redeemed-product",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <DispatchRedeemedProductHo />,
  },
  {
    path: "ho-manage-reports",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <Reports />,
  },
  {
    path: "send-notification",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <SendNotificationHo />,
  },
  {
    path: "ho-feedback",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <Feedback />,
  },
  {
    path: "ho-admin-settings",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER],
    component: <AdminSettings />,
  },
  {
    path: "my-profile",
    roles: [ROLE.HO_ADMIN, ROLE.HO_USER, ROLE.FA_ADMIN, ROLE.FA_USER],
    component: <MyProfile />,
  },
];
